<template lang="pug">
ul.pagination(v-if="pages > 1")
    //- first page
    li.page-item(:class="{ disabled: value === 1 }")
        span.page-link(v-if="value === 1") &laquo;
        button.page-link(v-else, @click="$emit('input', 1)") &laquo;

    //- previous page
    li.page-item(:class="{ disabled: value === 1 }")
        span.page-link(v-if="value === 1") &lsaquo;
        button.page-link(v-else, @click="$emit('input', value - 1)") &lsaquo;

    //- show gap?
    li.page-item.disabled(v-if="value > ELLIPSIS_THRESHOLD + 1")
        span.page-link ...

    //- dynamic pages (incl. current)
    li.page-item(v-for="page in pageRange", :class="{ active: value === page }")
        span.page-link(v-if="value === page") {{ page }}
        button.page-link(v-else, @click="$emit('input', page)") {{ page }}

    //- show gap?
    li.page-item.disabled(v-if="value < pages - ELLIPSIS_THRESHOLD && pages > 2 * ELLIPSIS_THRESHOLD")
        span.page-link ...

    //- next page
    li.page-item(:class="{ disabled: value === pages }")
        span.page-link(v-if="value === pages") &rsaquo;
        button.page-link(v-else, @click="$emit('input', value + 1)") &rsaquo;

    //- last page
    li.page-item(:class="{ disabled: value === pages }")
        span.page-link(v-if="value === pages") &raquo;
        button.page-link(v-else, @click="$emit('input', pages)") &raquo;
</template>

<script>
const ELLIPSIS_THRESHOLD = 3

export default {
    props: {
        // current Page
        value: {
            type: Number,
            default: 1
        },
        // total number of pages
        pages: {
            type: Number,
            default: 1
        }
    },
    data () {
        return {
            ELLIPSIS_THRESHOLD
        }
    },
    computed: {
        pageRange () {
            const start = this.value < ELLIPSIS_THRESHOLD + 1 ? 1 : this.value - ELLIPSIS_THRESHOLD
            const end = Math.min(this.value + ELLIPSIS_THRESHOLD, this.pages)

            const pages = []
            for (let i = start; i <= end; i++) {
                pages.push(i)
            }

            return pages
        }
    }
}
</script>
